import { render, staticRenderFns } from "./ShipIndexItem.vue?vue&type=template&id=fdf27c8c&scoped=true"
import script from "./ShipIndexItem.vue?vue&type=script&lang=js"
export * from "./ShipIndexItem.vue?vue&type=script&lang=js"
import style0 from "./ShipIndexItem.vue?vue&type=style&index=0&id=fdf27c8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf27c8c",
  null
  
)

export default component.exports